import React, { } from "react";
import "./index.scss";
import {clientEmail} from "../../../utils/constants";

const TermContact = ({ id = "" }) => {
    return (
        <>
            <section className="content-section" id={id}>
                <h2>How to Contact Us</h2>
                <p>
                    If you have any questions or requests in connection with this Notice or other privacy-related matters, please send an email to <a href={`mailto:${clientEmail}`}>{clientEmail}</a>.
                </p>
                <p>
                    Alternatively, inquiries may be addressed to:
                </p>
                <div className="address">
                    Compliance & Ethics <br />
                    TRAINED, Inc <br />
                    11 Parkway Center, Suite 100<br />
                    Pittsburgh, PA  15220<br />
                    USA
                </div>
            </section>
        </>
    )
};
export default TermContact;